module.exports = __webpack_public_path__ + "assets/img/title-01b6f7c9.png";